export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14452.445178af.jpg";